// Merges a refreshed first page of the notification history into the
// notifications already loaded, so a periodic or push-triggered refresh adds
// what is new without dropping the older pages the user loaded with
// "Load more".
//
// Kept as a CommonJS module so Jest can load it without transpiling modules.
// Avoid builtins that babel-plugin-transform-runtime rewrites into imports
// (e.g. Object.assign, Set): an injected import turns the file into an ES module
// for webpack, which then ignores module.exports.

// Both lists are newest first. The refreshed page wins for the notifications it
// contains (e.g. their read state), and loaded notifications that are no longer
// on it keep their place after it.
function mergeRefreshedFirstPage (loaded, firstPage) {
  const refreshed = firstPage || []
  const refreshedIds = {}
  refreshed.forEach(notification => {
    refreshedIds[notification.id] = true
  })
  const older = (loaded || []).filter(notification => !refreshedIds[notification.id])
  return refreshed.concat(older)
}

// Appends the next page loaded with "Load more". Notifications that arrived
// since the last refresh shift the pages on the server, so the next page can
// repeat a few already loaded; those are skipped.
function appendNextPage (loaded, nextPage) {
  const current = loaded || []
  const loadedIds = {}
  current.forEach(notification => {
    loadedIds[notification.id] = true
  })
  return current.concat((nextPage || []).filter(notification => !loadedIds[notification.id]))
}

module.exports = {
  appendNextPage,
  mergeRefreshedFirstPage
}



// WEBPACK FOOTER //
// ./src/utils/notification-history.js